const $ = jQuery.noConflict();

'use strict';
const Reseller = {

	$domSearchBtn: $('.js-map-drop__submit'),
	$domMapDropSearch: $('.js-map-drop__search'),
	$domHiddenContent: $('.js-map-drop__drop-item-hidden'),
	$domShownedContent: $('.map-drop__drop-item-top'),
	$domDropItem: $('.js-map-drop__drop-item'),
	$domDropImage: $('.js-map-drop__image'),
	$domMapDropContent: $('.js-map-drop__content'),
	$domShapeWrap: $('.js-map-drop__shape-wrap'),
	$domShapePopup: $('.js-map-drop__shape-popup'),

	classDropShow: 'map-drop-show',
	clasDropActive: 'map-drop-active',
	classShapeActive: 'shape-active',

	init: function() {
		// this.showDrops();
		this.dropDown();
		this.mapShapes();
	},

	mapShapes: () => {
		Reseller.$domDropImage.on('click', function() {
			if(!$(this).parent().hasClass(Reseller.classShapeActive)) {
				Reseller.$domShapeWrap.removeClass(Reseller.classShapeActive);
				$(this).parent().addClass(Reseller.classShapeActive);
			}else {
				$(this).parent().removeClass(Reseller.classShapeActive);
			}
		});
	},

	// showDrops: () => {
	//
	// 	Reseller.$domSearchBtn.on('click', function() {
	// 		$(this).parents('.map-drop').find(Reseller.$domMapDropContent).addClass(Reseller.classDropShow);
	// 	});
	//
	// 	$(Reseller.$domMapDropSearch).on('click', function() {
	// 		$(Reseller.$domMapDropContent).removeClass(Reseller.classDropShow);
	// 	});
	// },

	dropDown: () => {
		$('.map-drop__drop-item-top').on('click', function() {
			if(!$(this).parent().hasClass(Reseller.clasDropActive)) {
				Reseller.$domDropItem.removeClass(Reseller.clasDropActive);
				Reseller.$domHiddenContent.stop().slideUp();
				$(this).parent().addClass(Reseller.clasDropActive);
				$(this).next().stop().slideDown();
			}else {
				$(this).parent().removeClass(Reseller.clasDropActive);
				$(this).next().stop().slideUp();
			}
		});
	},
};
export default Reseller;
